import { autoinject, transient } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/reports/reports.constants";
import { GetAllReportsResponse, GetCustomerReportsResponse, GetReportsResponse, IsCompanyReportPurchasedResponse, SaveCustomerReportsRequest, SaveCustomerReportsResponse } from "../../models/reports/reports.models";

@autoinject()
@transient()
export class ReportsService {

    constructor(private requestClient: RequestClientService) { }

    public isCompanyReportPurchased(productCode: string, companyId: number, includePendingOrders: boolean): Promise<IsCompanyReportPurchasedResponse> {
        return this.requestClient.post(Urls.IsCompanyReportPurchased, {}, { productCode, companyId, includePendingOrders });
    }

    public getReports(entityId: number, entityTypeId: number): Promise<GetReportsResponse> {
        return this.requestClient.get(Urls.GetReports, { entityId, entityTypeId });
    }

    public getAllReports(): Promise<GetAllReportsResponse> {
        return this.requestClient.get(Urls.GetAllReports, {});
    }

    public getCustomerReports(customerId: number): Promise<GetCustomerReportsResponse> {
        return this.requestClient.get(Urls.GetCustomerReports, { customerId: customerId });
    }

    public saveCustomerReports(request: SaveCustomerReportsRequest): Promise<SaveCustomerReportsResponse> {
        return this.requestClient.post(Urls.SaveCustomerReports, {}, request);
    }

    public getReportIdByGuid(reportGuid: string): Promise<number> {
        return this.requestClient.get(Urls.GetReportIdByGuid, { reportGuid: reportGuid });
    }

    public getFullReportName(reportId: number, entityId?: number, entityTypeId?: number): Promise<string> {
        return this.requestClient.get(Urls.GetFullReportName, { reportId: reportId, entityId: entityId, entityTypeId: entityTypeId });
    }

    public isCompanyReportActiveSubscription(reportId: number): Promise<boolean> {
        return this.requestClient.get(Urls.IsCompanyReportActiveSubscription, { reportId });
    }
}